import React, { useEffect, useReducer, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "tailwindcss/tailwind.css";
import FirebaseService from "../services/FirebaseService";
import { actionTypes, initialState, reducer } from "./Reducer/Reducer";
import ManageLinksSection from "./Sections/ManageLinksSection";
import PreviewSection from "./Sections/PreviewSection";
import ProfileSection from "./Sections/ProfileSection";
import DragDropBuilder from "./DragAndDrop/Dragable";

const AdminDashboard = () => {
  // Sign-out function
  const handleSignOut = () => {
    localStorage.clear();
    window.location.href = `/`;
  };

  return (
    // <DndProvider backend={HTML5Backend}>
    //   <div className="flex h-screen bg-gray-100">
    //     {/* Left Panel */}
    //     <div className="w-full md:w-1/1 bg-white p-4 shadow-lg overflow-y-scroll min-h-screen">
    //       {/* Pass the user data as props to ProfileSection */}
    //       <div className="shadow-lg p-4">
    //         <ProfileSection
    //           profileImage={userInfoData?.photo_url}
    //           backgroundImage={ userInfoData?.background_image
    //           }
    //           // bio={bio || userInfoData?.bio}
    //           profileName={ userInfoData?.display_name}
    //         />

    //         {/* Manage Links Section */}
    //         <ManageLinksSection
    //           links={links}
    //           dispatch={dispatch}
    //           actionTypes={actionTypes}
    //           userInfoData={userInfoData}
    //           firebase_uid={userInfoData?.firebase_uid}
    //           getUserInfo={getUserInfo}
    //         />
    //       </div>
    //     </div>

    //     {/* Right Panel - Live Preview */}
    //     <PreviewSection
    //       profileImage={userInfoData?.photo_url}
    //       backgroundImage={userInfoData?.background_image}
    //       bio={userInfoData?.bio}
    //       profileName={userInfoData?.display_name}
    //       // profilePosition={profilePosition || userInfoData?.profilePosition}
    //       // profileColor={profileColor || userInfoData?.profileColor}
    //       userInfoData={userInfoData}
    //       templateType="template1"
    //     />
    //   </div>

    // </DndProvider>
    <>
      <DragDropBuilder />
      {/* Sign-out button */}
      <div className="absolute bottom-10 right-10">
        <button
          onClick={handleSignOut}
          className="bg-red-500 text-white py-2 px-4 rounded-full shadow-lg hover:bg-red-600"
        >
          Sign Out
        </button>
      </div>
    </>
  );
};

export default AdminDashboard;
